<script lang="ts">
import VIcon    from "@/lib/components/VIcon/VIcon.vue";
import VSvgIcon from "@/lib/components/VSvgIcon/VSvgIcon.vue";

/** Иконки навигации из Figma - id совпадают с именами файлов в src/assets/icons-set */
const NAV_ICONS: string[] = [
	'action-key',
	'checklist-rtl',
	'tab-recent',
	'filter-list',
	'pallet',
	'assignment-add',
	'format-list-bulleted',
	'deployed-code-update',
	'calendar-plans',
	'calendar-month',
	'manage-accounts',
	'location-on',
	'category',
	'group-add',
	'route',
	'contract',
	'list-alt-check',
	'factory',
	'order-approve',
	'add-shopping-cart',
	'move-shopping-cart',
	'trolley',
	'straighten',
	'design-services',
	'work',
	'unknown-document',
	'warehouse',
	'circle',
	'local-shipping',
	'orders',
	'tune',
	'grid-view',
  'prices',

];

const MATERIAL_FONT_ICONS: string[] = ['cancel', 'check', 'arrow_drop_down', 'settings', 'info', 'warning'];

export default defineComponent({
	name: "IconSample",

	components: { VIcon, VSvgIcon },

	setup() {
		return {
			NAV_ICONS,
			MATERIAL_FONT_ICONS,
		};
	},
});
</script>

<template>
	<h3>SVG-спрайт <code>src/assets/icons-set/*.svg</code></h3>
	<p>Через <code>&lt;VSvgIcon name="..." /&gt;</code> - viewBox символа берётся из спрайта</p>

	<div class="content__icons">
		<div
			v-for="name in NAV_ICONS"
			:key="name"
			class="content__icon-item"
		>
			<VSvgIcon :name="name" />
			<p>{{ name }}</p>
		</div>
	</div>

	<h3>Material Symbols (шрифт)</h3>
	<p>Через <code>&lt;VIcon material="..." /&gt;</code></p>

	<div class="content__icons">
		<div
			v-for="name in MATERIAL_FONT_ICONS"
			:key="name"
			class="content__icon-item"
		>
			<VIcon :material="name" />
			<p>{{ name }}</p>
		</div>
	</div>
</template>
